<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on }"/>
    </template>

    <v-card>
      <v-card-title
        class="title grey lighten-4"
        primary-title
      >
        Novidades
      </v-card-title>
      <v-card-text>
         <br />
      <span class="subtitle-1">Agora ao invés de mandar todas suas imagens separadamente, você pode junta-las todas em um arquivo Compactado.</span> <br />
      <span class="subtitle-1">O formato de arquivo suportado é ZIP.</span> <br />
      <span class="subtitle-1">Para compactar as imagens, basta selecionar as imagens desejadas e apertar com botão direito do Mouse</span> <br />
      <span class="subtitle-1">e selecionar a opção para comprimi-las (Linux e MAC) ou Enviar para Pasta Compactada (Windows).</span> <br />
      <span class="subtitle-1">Lembre-se de que as imagens devem ser selecionadas diretamente, ou seja, NÃO devem ser colocadas dentro de uma pasta.</span> <br /> <br />
      <img src="/images/tutoimagenszip.jpg">
      <br />
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="active = false"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "ProcessingNewsUpload",
    data: () => ({
      active: false,
    }),
  }
</script>